import styled from 'styled-components'

import { FlexBox } from '../../../components/Base/FlexBox'
import { Text } from '../../../components/Text/Text'
import { primaryBlack, white } from '../../../theme/colors'

export function ScorePill({
  score,
  color,
  backgroundColor,
  isPercentage,
  size = 'large',
}: {
  score?: number | null
  color?: string | null
  backgroundColor?: string | null
  isPercentage?: boolean | null
  size?: 'medium' | 'large'
}) {
  const isLarge = size === 'large'
  const mt = isLarge ? 0.5 : 0.7

  if (score === null || score === undefined) {
    return null
  }

  return (
    <Wrapper gap="4px" $isLarge={isLarge}>
      <ScorePillWrapper $backgroundColor={backgroundColor} $isLarge={isLarge}>
        <Text variant={isLarge ? 'header2' : 'header3'} fontColor={color ?? primaryBlack} mt={mt}>
          {Math.floor(score)}
        </Text>
      </ScorePillWrapper>
      {isPercentage && (
        <Text
          variant={isLarge ? 'header2' : 'header3'}
          fontColor={color ?? primaryBlack}
          mt={mt + (isLarge ? 0.3 : 0.1)}
        >
          %
        </Text>
      )}
    </Wrapper>
  )
}

const Wrapper = styled(FlexBox)<{ $isLarge: boolean }>`
  * {
    font-size: ${({ $isLarge }) => ($isLarge ? 20 : 16)}px !important;
  }
`

const ScorePillWrapper = styled(FlexBox)<{ $backgroundColor?: string | null; $isLarge: boolean }>`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ $backgroundColor }) => $backgroundColor ?? white};
  border-radius: 3px;
  width: ${({ $isLarge }) => ($isLarge ? 40 : 32)}px;
  height: ${({ $isLarge }) => ($isLarge ? 40 : 32)}px;
  padding: 5px 3px;
`
